import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import type { ColorPalette } from '../constants/colors';
import { useAppColors } from '../context/PreferencesContext';
import type { TrackingMapColors } from '../utils/trackingMapHtml';

export function trackingMapColors(palette: ColorPalette): TrackingMapColors {
  return {
    checkIn: palette.success,
    stay: palette.warning,
    comment: palette.info,
    checkOut: palette.error,
    current: palette.textPrimary,
    route: palette.primary,
  };
}

const ITEMS: { key: keyof TrackingMapColors; label: string }[] = [
  { key: 'checkIn', label: 'Check-in' },
  { key: 'stay', label: 'Long stay' },
  { key: 'comment', label: 'Comment' },
  { key: 'checkOut', label: 'Check-out' },
  { key: 'current', label: 'Current location' },
  { key: 'route', label: 'Route' },
];

/** showCurrent: the visit is live, so the map has a current-location marker. */
export function TrackingMapLegend({ showCurrent = false }: { showCurrent?: boolean }) {
  const palette = useAppColors();
  const colors = trackingMapColors(palette);
  const items = showCurrent ? ITEMS : ITEMS.filter(item => item.key !== 'current');
  return (
    <View style={styles.row} accessibilityLabel="Map legend">
      {items.map(item => (
        <View key={item.key} style={styles.item}>
          <View
            style={[
              item.key === 'route' ? styles.line : styles.dot,
              { backgroundColor: colors[item.key] },
            ]}
          />
          <Text style={[typography.caption, { color: palette.textSecondary }]}>
            {item.label}
          </Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', gap: spacing.md },
  item: { flexDirection: 'row', alignItems: 'center', gap: spacing.xs },
  dot: { width: 10, height: 10, borderRadius: 5 },
  line: { width: 16, height: 4, borderRadius: 2 },
});
